import { get } from 'lodash';
import React from 'react';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import Main from '@src/pages/main/Main';
import AppMain from '@src/pages/AppExperience/index';
import PageNotFound from '@src/components/common/PageNotFound/index';
import { WithPersistence } from '@src/pages/index';
import { validPresetKeys, presetTitles } from '@src/components/common/Dashboard/UseCases/utils';

const RenderPage = {
  EI: Main,
  AI: Main,
  APP: AppMain,
}[CURRENT_PRODUCT_MODE];

const PresetDashboardPage = (props) => {
  const pageKey = get(props, 'match.params.key', -1);
  if (validPresetKeys.includes(pageKey)) {
    return (
      <WithPersistence>
        <RenderPage {...props} title={presetTitles[pageKey]} />
      </WithPersistence>
    );
  }
  return <PageNotFound />;
};

const presetRenderer = (props) => <PresetDashboardPage {...props} />;

export default presetRenderer;
